/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import find from 'lodash/find';
import isNil from 'lodash/isNil';


const TWIACoveragesHelper = (coverages) => {



    const getCoverage = ({ publicID, selected }) => {
        if (isNil(selected)) {
            return find(coverages, ['publicID', publicID]) || {};
        }

        return find(coverages, { publicID, selected }) || {};
    };


    const getCoverageTerm = ({ coveragePublicID, covSelected = undefined, termPublicID }) => {
        const cov = getCoverage({ publicID: coveragePublicID, selected: covSelected });

        return find(cov.terms, {
            publicID: termPublicID,
        }) || {};
    };

    return {
        getCoverage,
        getCoverageTerm
    };
};

export default TWIACoveragesHelper;
